// src/utils/pdf.ts
import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'

export async function generatePDF(
  htmlContent: string,
  iconUrl: string,
  contractId: string = 'de Prestaçao de Serviço'
) {
  const pageHeightPx = 1040
  const pageWidthPx = 794
  const pageHeightMM = 297
  const pageWidthMM = 210

  const container = document.createElement('div')
  container.innerHTML = htmlContent
  container.style.width = `${pageWidthPx}px`
  container.style.padding = '80px 60px'
  container.style.fontFamily = 'Arial'
  container.style.fontSize = '11.5pt'
  container.style.lineHeight = '1.5'
  container.style.textAlign = 'justify'
  container.style.backgroundColor = 'white'
  container.style.color = 'black'
  container.style.position = 'absolute'
  container.style.visibility = 'hidden'
  container.style.zIndex = '-1'
  container.style.boxSizing = 'border-box'

  document.body.appendChild(container)

  const children = Array.from(container.childNodes)
  const pdf = new jsPDF('p', 'mm', 'a4')

  // Marca d’água
  const svgText = await fetch(iconUrl).then(res => res.text())
  const svgBlob = new Blob([svgText], { type: 'image/svg+xml' })
  const url = URL.createObjectURL(svgBlob)
  const svgImage = new Image()
  svgImage.src = url
  await new Promise<void>(resolve => (svgImage.onload = () => resolve()))
  const canvasForSvg = document.createElement('canvas')
  canvasForSvg.width = 300
  canvasForSvg.height = 300
  const ctx = canvasForSvg.getContext('2d')
  if (ctx) {
    ctx.globalAlpha = 0.1
    ctx.drawImage(svgImage, 0, 0, 300, 300)
  }
  const watermarkRaster = canvasForSvg.toDataURL('image/png')

  let currentPage = document.createElement('div')
  currentPage.style.width = `${pageWidthPx}px`
  currentPage.style.height = `${pageHeightPx}px`
  currentPage.style.padding = '80px 60px'
  currentPage.style.boxSizing = 'border-box'
  currentPage.style.position = 'relative'
  currentPage.style.backgroundColor = 'white'
  currentPage.style.fontFamily = 'Arial'
  currentPage.style.fontSize = '11.5pt'
  currentPage.style.lineHeight = '1.5'
  currentPage.style.textAlign = 'justify'

  document.body.appendChild(currentPage)

  for (const child of children) {
    currentPage.appendChild(child)
    if (currentPage.scrollHeight > pageHeightPx) {
      currentPage.removeChild(child)

      const canvas = await html2canvas(currentPage, { scale: 2, useCORS: true })
      const imgData = canvas.toDataURL('image/jpeg', 1.0)
      pdf.addImage(imgData, 'JPEG', 0, 0, pageWidthMM, pageHeightMM)
      pdf.addImage(watermarkRaster, 'PNG', pageWidthMM / 2 - 60, pageHeightMM / 2 - 60, 120, 120, undefined, 'NONE')
      pdf.addPage()

      document.body.removeChild(currentPage)
      currentPage = document.createElement('div')
      currentPage.style.width = `${pageWidthPx}px`
      currentPage.style.height = `${pageHeightPx}px`
      currentPage.style.padding = '80px 60px'
      currentPage.style.boxSizing = 'border-box'
      currentPage.style.position = 'relative'
      currentPage.style.backgroundColor = 'white'
      currentPage.style.fontFamily = 'Arial'
      currentPage.style.fontSize = '11.5pt'
      currentPage.style.lineHeight = '1.5'
      currentPage.style.textAlign = 'justify'
      document.body.appendChild(currentPage)

      currentPage.appendChild(child)
    }
  }

  const canvas = await html2canvas(currentPage, { scale: 2, useCORS: true })
  const imgData = canvas.toDataURL('image/jpeg', 1.0)
  pdf.addImage(imgData, 'JPEG', 0, 0, pageWidthMM, pageHeightMM)
  pdf.addImage(watermarkRaster, 'PNG', pageWidthMM / 2 - 60, pageHeightMM / 2 - 60, 120, 120, undefined, 'NONE')

  document.body.removeChild(currentPage)
  document.body.removeChild(container)
  pdf.save(`Contrato ${contractId}.pdf`)
}
